import React from "react"
import Tabs from "@material-ui/core/Tabs"
import Tab from "@material-ui/core/Tab"

const OptionsMenu = (props) => {
  const { option, handleChange, classes } = props

  return (
    <div className={classes.loginMenu}>
      <Tabs
        value={option}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
        aria-label="disabled tabs example"
      >
        <Tab wrapped label="Login" />
        {/* <Tab wrapped label="Sign Up" disabled />
        <Tab wrapped label="Forgot Password" disabled /> */}
      </Tabs>
    </div>
  )
}

export default OptionsMenu